export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
// export const BOSC_ID = +process.env.REACT_APP_BOSC_ID || 0;
